import React from 'react';
import styled from 'styled-components';
import media from "../../helpers/media";
import creativo from "../../assets/creativo.jpg"
import fantastico from "../../assets/fantastico.jpg"
import { Link } from "react-router-dom";

export const ResumeChoice = ({ closePopup }) => (
    <Container onClick={closePopup}>
        <Body>
            <Header>Choose One</Header>
            <ImgContainer>
                <Link to={{
                    pathname: `/editor`,
                    query: { template: "creativo" }
                }}><Img src={creativo} alt="resume-creativo" /></Link>
                <Font>Creativo</Font>
            </ImgContainer>
            <ImgContainer>
                <Link to={{
                    pathname: `/editor`,
                    query: { template: "fantastico" }
                }}><Img src={fantastico} alt="resume-fantastico" /></Link>
                <Font>Fantastico(Beta)</Font>
            </ImgContainer>
            <CloseIcon onClick={closePopup}>x</CloseIcon>
        </Body>
    </Container>);

const Container = styled.div`
    position: fixed;
    width: 100%;  
    height: 100% !important;
    background-color: rgba(0,0,0, 0.7);  
    padding-top:35px;
    overflow:scroll;
    @media ${media.tablet}{
        display:flex;
        overflow:hidden;
        padding-top:0;
        justify-content:center;
    }
`;

const Img = styled.img`
    height: 30em;
    transition: all .4s ease-in-out;
    &:hover{
        transform: scale(1.1);
        background-color:inherit
    };
`;

const ImgContainer = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    height:inherit;
    padding:20px 0;
`;

const Font = styled.div`
    font-size:22px;
    font-weight:bold;
    margin-top:15px;
    font-family:Jura;
    color:#ece2e2;
    @media ${media.tablet}{
        font-size:18px;
    }
`;

const Header=styled.h1`
    position:inherit;
    top:5px;
    font-size:30px;
    font-family:Jura;
    color:#ece2e2;
    @media ${media.tablet}{
        position: fixed;
        top: 23px;
    }
`;

const Body = styled.div`
    width: 100%;
    position: relative;
    transition: all 5s ease-in-out;
    display:flex;
    justify-content: center;
    flex-direction:column;
    align-items:center;
    padding-bottom:25px;

    @media ${media.tablet}{
        width: 70%;
        margin: 50px auto;
        flex-direction:row;
        justify-content: space-around;
        overflow:hidden;
    }
`;

const CloseIcon = styled.a`
    position: fixed;
    cursor: pointer;
    top: 4px;
    right: 15px;
    transition: all 200ms;
    font-size: 38px;
    font-weight: bold;
    text-decoration: none;
    color: #fff;
    @media ${media.tablet}{
        position:absolute;
    }
`;